import { valid, Validator } from "lego-gui-lib";
import { t } from "../core/i18n/i18n";

export const RangeIncOrEmpty = (min: number, max: number): Validator =>
  valid(
    v => (v >= min && v <= max) || v == null,
    "lego:validators.numberRangeOrEmpty",
    t("Must be inside of range <{{min}}, {{max}}> or empty")(),
    { min, max }
  );
